import target11 from "../../assets/images/target11.svg";
import vision11 from "../../assets/images/vision11.svg";
import clock11 from "../../assets/images/clock11.svg";

export default function Vision() {
  return (
    <div className="w-full mt-6 lg:mt-14">
      <div className="container mx-auto p-3 flex flex-col gap-3 lg:flex-row lg:items-center lg:gap-3">
        <div className="lg:w-3/12 w-full">
          <p className="text-xl md:text-2xl lg:text-3xl font-semibold text-[#033F6A] w-[350px] lg:w-[220px]">
            Tầm nhìn & sứ mệnh của chúng tôi
          </p>
        </div>
        <div className="lg:w-9/12 w-full bg-white flex flex-col lg:flex-row lg:gap-3 gap-3">
          <div className="w-full lg:w-1/2 h-[276px] bg-white border border-solid border-[#E2E2E2] px-[30px] py-[24px] flex flex-col gap-3 shadow-custom rounded-[16px]">
            <div className="w-12 h-12 rounded-full bg-[#EFFFE3] flex items-center justify-center p-2">
              <img src={vision11} alt="vi" />
            </div>
            <div>
              <p className="text-lg md:text-xl lg:text-2xl font-semibold text-[#033F6A]">
                Tầm nhìn
              </p>
            </div>
            <div>
              <p className="text-sm md:text-base font-normal text-[#333333]">
                Trở thành tập đoàn công nghệ hàng đầu, dẫn dắt xu hướng phát
                triển bền vững trong lĩnh vực giáo dục, sức khỏe và đào tạo
              </p>
            </div>
          </div>
          <div className="w-full lg:w-1/2 h-[276px] bg-white px-[30px] py-[24px] border border-solid border-[#E2E2E2]  flex flex-col gap-3 shadow-custom rounded-[16px]">
            <div className="w-12 h-12 rounded-full bg-[#EFFFE3] flex items-center justify-center p-2">
              <img src={target11} alt="vi" />
            </div>
            <div>
              <p className="text-lg md:text-xl lg:text-2xl font-semibold text-[#033F6A]">
                Sứ mệnh
              </p>
            </div>
            <div>
              <p className="text-sm md:text-base text-[#333333] font-normal">
                Chúng tôi cam kết mang lại giá trị thiết thực và bền vững cho
                cộng đồng thông qua các sản phẩm và dịch vụ đột phá, giúp nâng
                cao chất lượng cuộc sống và nền tảng học tập
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
